export { impressionEventConfiguration } from './impression-configuration';